/**
 * FunShine Cartridge Registry
 * Registers all four official game cartridges.
 */
import { Cartridge as Gomoku } from '../games/gomoku/index.js';
import { Cartridge as Battleship } from '../games/battleship/index.js';
import { Cartridge as Hangman } from '../games/hangman/index.js';
import { Cartridge as BullsAndCows } from '../games/bulls-and-cows/index.js';

const registry = new Map();

export function registerCartridge(cartridge) {
  if (!cartridge || !cartridge.id) {
    throw new Error('Invalid cartridge: missing "id" property');
  }
  registry.set(cartridge.id, cartridge);
}

export function getCartridge(id) {
  return registry.get(id) || null;
}

export function getAllCartridges() {
  return Array.from(registry.values());
}

// Automatically register all four games
registerCartridge(Gomoku);
registerCartridge(Battleship);
registerCartridge(Hangman);
registerCartridge(BullsAndCows);
